import { Grid } from "@mui/material";
import { FormAutoComplete } from "../../../../../components/form";
import { useEffect } from "react";

import InputText from "@/components/form/InputText";

const clinicalStatusOptions = [
  {
    value: "active",
    label: "Ativo",
  },
  {
    value: "inactive",
    label: "Inativo",
  },
  {
    value: "resolved",
    label: "Resolvido",
  },
];

const categoryOptions = [
  {
    value: "food",
    label: "Alimento",
  },
  {
    value: "medication",
    label: "Medicamento",
  },
  {
    value: "environment",
    label: "Ambiente",
  },
  {
    value: "biologic",
    label: "Biológico",
  },
];

const criticalityOptions = [
  {
    value: "low",
    label: "Baixo",
  },
  {
    value: "high",
    label: "Alto",
  },
  {
    value: "unable-to-assess",
    label: "Incapaz de avaliar",
  },
];

const verificationStatusOptions = [
  {
    value: "unconfirmed",
    label: "Não confirmado",
  },
  {
    value: "confirmed",
    label: "Confirmado",
  },
  {
    value: "presumed",
    label: "Presumido",
  },
  {
    value: "refuted",
    label: "Refutado",
  },
];

export function AllergyForm({ setValue, control, editCondition }: any) {
  useEffect(() => {
    if (editCondition) {
      setValue("allergy.id", editCondition?.fullResource?.id);
      setValue("allergy.substance", editCondition?.description);
      setValue("allergy.category", {
        label: editCondition?.category,
        value: editCondition?.fullResource?.category?.[0],
      });
      setValue("allergy.criticality", {
        label: editCondition?.criticality,
        value: editCondition?.fullResource?.criticality,
      });
      setValue("allergy.clinicalStatus", {
        label: editCondition?.clinicalStatus,
        value: editCondition?.fullResource?.clinicalStatus?.coding?.[0]?.code,
      });
      setValue("allergy.verificationStatus", {
        label: editCondition?.verificationStatus,
        value:
          editCondition?.fullResource?.verificationStatus?.coding?.[0]?.code,
      });
    }
  }, [editCondition, setValue]);

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={2}
    >
      <Grid item xs={12}>
        <InputText
          name="allergy.substance"
          label="Substancia"
          required
          control={control}
          autoFocus
          defaultValue={editCondition?.description || ""}
        />
      </Grid>
      <Grid item xs={6}>
        <FormAutoComplete
          loading={false}
          name="allergy.category"
          label="Categoria"
          required
          control={control}
          selectOptions={categoryOptions}
          defaultValue={{
            label: editCondition?.category,
            value: editCondition?.category,
          }}
        />
      </Grid>

      <Grid item xs={6}>
        <FormAutoComplete
          loading={false}
          name="allergy.criticality"
          label="Criticidade"
          required
          control={control}
          selectOptions={criticalityOptions}
          defaultValue={editCondition?.criticality || ""}
        />
      </Grid>
      <Grid item xs={6}>
        <FormAutoComplete
          loading={false}
          name="allergy.clinicalStatus"
          label="Status clínico"
          required
          control={control}
          selectOptions={clinicalStatusOptions}
          defaultValue={editCondition?.clinicalStatus || ""}
        />
      </Grid>
      <Grid item xs={6}>
        <FormAutoComplete
          loading={false}
          name="allergy.verificationStatus"
          label="Status de verificação"
          required
          control={control}
          selectOptions={verificationStatusOptions}
          defaultValue={editCondition?.verificationStatus || ""}
        />
      </Grid>
    </Grid>
  );
}
